import { render, staticRenderFns } from "./Wallpapers.vue?vue&type=template&id=6482bd99"
import script from "./Wallpapers.vue?vue&type=script&lang=js"
export * from "./Wallpapers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports